export const SERVICES = [
  { id: 1, name: "Medication Management" },
  { id: 2, name: "Psychosis" },
  { id: 3, name: "Depression Treatment" },
  { id: 4, name: "TeleHealth" },
  { id: 5, name: "Anxiety" },
  { id: 6, name: "Bipolar" },
  { id: 7, name: "OCD" },
  { id: 8, name: "PTSD" },
  { id: 9, name: "Gene_Sight Test" },
];
